import { useConfig } from '@@/common/services/useConfig';

import ContactSupport, { TContactSupport } from './ContactSupport';

function ContactSupportForTenant(props: Omit<TContactSupport, 'supportEmail'>) {
  const {
    config: { supportEmail },
  } = useConfig();

  return <ContactSupport supportEmail={supportEmail} {...props} />;
}

export default ContactSupportForTenant;
